import type { ProductCategoryRefDTO } from "@/modules/products/domain/types";

export function formatProductCategories(
  categories: ProductCategoryRefDTO[],
): string {
  return categories.map((category) => category.name).join(" / ");
}
